import { FC, HTMLAttributes, SyntheticEvent } from "react";
import cn from "classnames";
import styles from "./circle-button.module.scss";

const BUTTON_VARIABLES = {
  OUTLINE: "outline",
  TRANSPARENT: "transparent",
} as const;

const BUTTON_SIZES = {
  XSMALL: "x-small",
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
} as const;

type Values<T> = T[keyof T];
type CircleButtonSize = Values<typeof BUTTON_SIZES>;
type CircleButtonVariables = Values<typeof BUTTON_VARIABLES>;

type Props = {
  onClick?: (e: SyntheticEvent) => void;
  variables?: CircleButtonVariables;
  size?: CircleButtonSize;
  dataTestId?: string;
};

const CircleButton: FC<HTMLAttributes<HTMLButtonElement> & Props> = ({
  children,
  onClick,
  className,
  variables = BUTTON_VARIABLES.TRANSPARENT,
  size = BUTTON_SIZES.MEDIUM,
  dataTestId = "circle-button",
  ...other
}) => (
  <button
    onClick={onClick}
    className={cn(styles.button, styles[variables], styles[size], className)}
    data-test-id={dataTestId}
    {...other}
  >
    {children}
  </button>
);

export { CircleButton };
